module.exports = __webpack_public_path__ + "img/circuit-board.7ee68a7e.png";